import API from '@/api/Contact'
import MixinFactory from '@/store/mixin'
const Mixin = MixinFactory('Contact')

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
  addComment(store, payload) {
    store.item.comments.forEach(comment =>  comment.isProcessed = true )
    store.item.comments.push(payload)
  }
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
  mutate: Mixin.actions.mutate(API.mutate),
  remove: Mixin.actions.remove(API.delete),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
